export var InAppStatus;
(function (InAppStatus) {
    InAppStatus[InAppStatus["unread"] = 0] = "unread";
    InAppStatus[InAppStatus["read"] = 1] = "read";
})(InAppStatus || (InAppStatus = {}));
